import React from "react";
import styled from "styled-components";
import { Typography } from "../../general";
import { Avatar } from "../../social";
import { Flex } from "../../layouts";

interface ActivityFeedItemProps {
  user?: {
    name: string;
    avatarUrl?: string;
  };
  action: string;
  timestamp: string;
}

const ItemWrapper = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const ActivityFeedItem: React.FC<ActivityFeedItemProps> = ({ user, action, timestamp }) => {
  return (
    <ItemWrapper>
      <Avatar size="sm" src={user?.avatarUrl} name={user?.name} />
      <Flex direction="column" gap="xxs" style={{ marginLeft: 12 }}>
        <Typography variant="bodySmall" weight="medium">
          {user?.name || "System"} {action}
        </Typography>
        <Typography variant="caption" colorScheme="muted">
          {timestamp}
        </Typography>
      </Flex>
    </ItemWrapper>
  );
};